import { Injectable } from '@angular/core'
import { APIService } from 'api/module'
import { LicenseService, SocketService } from 'common/util/module'
import { IdentityService } from 'main/services/identity.service'
import { TapeJob } from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class TapeJobsService {
  runningJobsCount = 0
  jobs: TapeJob[] = []

  constructor (
    private api: APIService,
    private identity: IdentityService,
    private license: LicenseService,
    socket: SocketService,
  ) {
    socket.subject('ui:notification').subscribe(data => {
      if (data.subject === 'ltfs-job') {
        this.refresh()
      }
    })

    if (identity.loggedIn) {
      this.refresh()
    }
  }

  async refresh (): Promise<void> {
    if (!this.identity.hasPermission('ltfs:manage') || !this.license.hasComponent('ltfs')) {
      return
    }
    this.jobs = await this.api.tapeArchive.getAllTapeArchiveJobs({})
    this.runningJobsCount = this.jobs.filter(x => x.status === 'RUNNING' || x.status === 'QUEUED').length
  }
}
